import { Typography, Grid, Box } from '@mui/material';
import { ColorPalettes } from '../constants/ColorPalettes';
import { PageName } from '../index';
import { PageSegment } from '../..';

export function AboutTranslation(props: any) {
  const SubmitButton = () => {
    return (
      <button
        onClick={() => props.setActivePage(PageName.SignUp)}
        style={{
          width: '100%',
          height: '48px',
          color: '#FFFFFF',
          textAlign: 'left',
          margin: 'auto',
          marginBottom: '10px'
        }}
        className="bg-primary flex relative rounded"
      >
        <div className="text-base m-auto font-bold" style={{ whiteSpace: 'pre-wrap' }}>
          メールアドレスで新規登録
        </div>
      </button>
    );
  };

  const LoginButton = () => {
    return (
      <button
        onClick={() => props.setActiveSegment(PageSegment.Login)}
        style={{
          width: '100%',
          height: '48px',
          color: ColorPalettes.MAIN,
          borderColor: ColorPalettes.MAIN,
          textAlign: 'center',
          margin: 'auto'
        }}
        className="bg-transparent flex relative border-2 rounded"
      >
        <div className="text-base m-auto font-bold" style={{ whiteSpace: 'pre-wrap' }}>
          登録済みの方はログイン
        </div>
      </button>
    );
  };

  return (
    <>
      <Box sx={{ p: 2 }}>
        <Grid container direction={'row'} spacing={2}>
          <Grid item xs={0} md={3} sm={2} />
          <Grid item xs={12} md={6} sm={8}>
            <Grid container direction={'column'} spacing={2}>
              <Grid item xs={12} mt={2} sx={{ textAlign: 'center', maxWidth: '100% !important' }}>
                <Typography mb={2} pt={2} fontSize={'16px'} className="font-bold">
                  【重要なお知らせ】 <br />
                  LINEによる新規登録の変更について
                </Typography>
                <Typography mb={2} pt={2} fontSize={'14px'}>
                  ご利用いただきありがとうございます。
                  <br />
                  システム改善と利便性向上を図るため、
                  <br />
                  今後はメールアドレスとパスワードを使用した登録方法に移行していただく必要があります。
                  <br />
                  <br />
                  「メールアドレス新規登録」ボタンをクリックし、
                  <br />
                  手続きを始めてください。
                  <br />
                  ご不便をおかけしますが、
                  <br />
                  何卒ご理解のほどよろしくお願いいたします。
                  <br />
                </Typography>
                <Grid mb={2} pt={2}>
                  <SubmitButton />
                  <LoginButton />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </>
  );
}
